import styled from "styled-components";
import { mobileOnly, mobileAndTablet } from "_/style/media";
import { pagePadding } from "_/style/layout";

export const OuterWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  color: ${(p) => p.theme.text.default};
  gap: 2.25rem;
  ${pagePadding};
`;

export const Carousel = styled.ul`
  display: grid;
  gap: 1.5rem;
  padding: 0;
  margin: 0;
  overflow-y: hidden;
  height: 200px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
`;

export const HomeWidget = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 1rem;
`;

export const MachinesPrintingGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 2.25rem;

  ${mobileAndTablet`
    grid-template-columns: 1fr;
  `}
`;

export const QueueHistoryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.25rem;
  padding-bottom: 3rem;

  /* Below 1700px, stack vertically */
  @media (max-width: 1700px) {
    grid-template-columns: 1fr;
  }

  ${mobileAndTablet`
    grid-template-columns: 1fr;
  `}
`;

export const MachinesColumn = styled.div`
  min-width: 0;
`;

export const PrintingColumn = styled.div`
  min-width: 0;
`;

export const QueueColumn = styled.div`
  min-width: 0;
`;

export const HistoryColumn = styled.div`
  min-width: 0;
`;

export const NestedWidgetContainer = styled.div`
  display: flex;
  gap: 3rem;
  width: 100%;
  ${mobileOnly`
    flex-direction: column;
  `}
`;

export const UseRemainingWidth = styled.div`
  flex-grow: 1;
`;

export const HomeWidgetTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  h2 {
    margin: 0;
    padding: 0 0 0 1px;
    line-height: 1;
  }
`;

export const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  width: 300px;
  min-width: 300px;
  min-height: 100%;
  height: fit-content;
  flex-shrink: 0;
  background-color: ${(p) => p.theme.background.secondary};
  color: ${(p) => p.theme.text.default};
  padding: 1.25rem;
  ${mobileAndTablet`
    display: none;
  `}
`;
